import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { connect } from "react-redux";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: "100%",
      padding: "20px",
    },
    cardContent: {
      textAlign: "center",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: { color: "black" },
  })
);


interface Props {
}

const Dashboard: React.FC<Props> = ({
}) => {
  const classes = useStyles();

  return (
    <div style={{ width: "90%", margin: "60px auto" }}>
      <p>Welcome</p>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  
});

export default connect(mapStateToProps, {

})(Dashboard);
